import { PurchaseEvent } from '../../event'
import { sendEcommerceEventToGtm } from './handle-purchase/send-ecommerce-event-to-gtm'
import { sendToCribnotes } from './handle-purchase/send-to-cribnotes'
import { sendToGA } from './handle-purchase/send-to-ga'
import { sendToWebCustomerTool } from './handle-purchase/send-to-web-customer-tool'

export function handlePurchase(event: PurchaseEvent): void {
  // Strategyなどで抽象化して、 window.dataLayer初期化やdataLayerへのpushなどは一元化しつつ
  // 個別の目的に応じた変換処理は抽象化したい
  sendToGA(event)
  sendEcommerceEventToGtm(event)
  sendToWebCustomerTool(event)
  sendToCribnotes(event)
}
